export default "__VITE_ASSET__Uigf8_yP__"